export const CURRENT_USER = 'CURRENT_USER';

export const FEEDS = 'FEEDS';
export const FEED = 'FEED';
